import { render, staticRenderFns } from "./ConfigFormModal.vue?vue&type=template&id=0bc81ed3"
import script from "./ConfigFormModal.vue?vue&type=script&lang=js"
export * from "./ConfigFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports